import { OptGroup, Option } from 'rc-select'

import SelectElement from './Select'

import './style/css'

const Select = Object.assign(SelectElement, { Option, OptGroup })

export default Select
